import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { NAV_LINKS, CONTACT } from "@/data/site";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#081831] text-white">
      <div className="mx-auto max-w-7xl px-5 py-12 sm:px-8">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          {/* Brand */}
          <div>
            <Logo />
            <p className="mt-4 max-w-xs text-sm text-white/55">
              We build websites that win you more jobs — and grow them so you
              rank #1 on Google.
            </p>
          </div>

          {/* Nav */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-white/45">
              Navigation
            </h4>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="text-white/75 transition-colors hover:text-[#e9a31e]"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-white/45">
              Get in touch
            </h4>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href={`tel:${CONTACT.phoneRaw}`}
                  className="flex items-center gap-2.5 text-white/75 transition-colors hover:text-[#e9a31e]"
                >
                  <Phone className="h-4 w-4 text-[#e9a31e]" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  className="flex items-center gap-2.5 break-all text-white/75 transition-colors hover:text-[#e9a31e]"
                >
                  <Mail className="h-4 w-4 text-[#e9a31e]" /> {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6 text-sm text-white/45">
          © 2025 Online Office Solutions. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
